import React, { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import VistaPreviaDetalle from "../../components/promociones/VistaPreviaDetalle";
import usePromocionesStore from "../../store/promocionesStore";
import { iframeOrigin } from "../../utils/previewOrigin";
const Quill = ReactQuill.Quill;
window.Quill = Quill;

// Registra el módulo de redimensión
Quill.register("modules/imageResize", ImageResize.default || ImageResize);

const EditorPage = ({name }) => {
  const { datos, handleChange, error } = usePromocionesStore();
  const refIframes = useRef(null);
  const toolbarOptions = [
    [{ size: [ 'small', false, 'large' ]}],
    ['bold', 'italic', 'underline'],
    ['link', 'image'],
    [{ 'align': [] }],  
  ];

  const modules = {
    toolbar: {
      container: toolbarOptions,
    },
    imageResize: {
      modules: ['Resize', 'DisplaySize']
    }
  };

  const enviarImagenFlutter = () => {
    if (!refIframes.current?.contentWindow) return;
    refIframes.current.contentWindow.postMessage(
      { tipo: 'demo_promocion', payload: datos.detalle },
      iframeOrigin(refIframes.current)
    );
  }

  useEffect(() => {
    enviarImagenFlutter();
  }, [datos.detalle]);

  return (
    <>
      <div className="row mt-5" style={{ display: 'flex', height: '100%',  }}>
        <div className="col-md-8" style={{}}>
        <ReactQuill theme="snow" value={datos.detalle} onChange={(value) => handleChange({ target: { name: 'detalle', value } })} modules={modules} style={{height: '100%',width: '100%',paddingBottom: '20px', borderColor: error?.[name] ? 'red' : '', borderWidth: error?.[name] ? '1px' : '', borderStyle: error?.[name] ? 'solid' : '', borderRadius: error?.[name] ? '10px' : '' }}  />
        </div>
        {/* Aquí el iframe de 700px */}
        <VistaPreviaDetalle refIframes={refIframes}/>
      </div>
      {
        error?.[name] && (
            <div className="" style={{color: 'var(--danger-main)', fontSize: '15px',marginTop: '7px'}}>
                {error?.[name]}
            </div>
        )
      }
    </>
  );
};

export default EditorPage;
